import React from 'react'
import { Link } from 'react-router-dom'
import { Button } from 'antd'

import { PERMISSIONS } from '../../../common/constants'

import { PermissionGuard } from '../../../account/components/sections'
import { userDetailsPropType } from '../../prop-types'

const UsersTableActionColumn = ({ user }) => (
  <PermissionGuard permissions={PERMISSIONS.USER.UPDATE}>
    <Button>
      <Link to={user.id}>Edit</Link>
    </Button>
  </PermissionGuard>
)

UsersTableActionColumn.propTypes = {
  user: userDetailsPropType.isRequired,
}

export default UsersTableActionColumn
